/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Panoramica',
    lead: 'Indicatori chiave della piattaforma: fatturato, aziende e utenti attivi, e retention.',
    activeCompanies: 'Aziende attive',
    activeUsers: 'Utenti attivi',
    revenueThisMonth: 'Fatturato di questo mese',
    retention: 'Retention (mese su mese)',
    retentionUnavailable: 'Nessun dato ancora',
    retentionDetail: '{{retained}} aziende trattenute su {{total}}',
  },
} as const;
